import { gql } from 'graphql.macro';

export const submitSupportTicketTemplate = gql`
    mutation submitSupportTicket($name: String!, $email: String!, $message: String!, $pagePath: String) {
        submitSupportTicket(name: $name, email: $email, message: $message, pagePath: $pagePath)
    }
`;
